/** Words for artistic edits (beta): the request form, and the staff Studio queue. */
export const ART = {
  title: "Request an artistic edit",
  beta: "Beta",
  pitch: "Tell us what you want, and we'll make it for you.",
  open: "Request one",
  close: "Not now",
  about: "What is it about?",
  aboutPlaceholder: "A family dinner, a podcast episode, a talk…",
  wants: "What would you like us to make?",
  wantsPlaceholder: "A 30-second reel of the funniest moments, with music and captions…",
  audience: "Who is it for?",
  audiences: [
    { key: "social", label: "Social media" },
    { key: "family", label: "Friends & family" },
    { key: "fun", label: "Just for fun" },
    { key: "work", label: "Work" },
  ],
  shape: "Shape",
  shapes: [
    { key: "vertical", label: "Vertical" },
    { key: "wide", label: "Wide" },
    { key: "either", label: "Either" },
  ],
  feedback: "I'll give feedback on the edit",
  fine: "Beta: free while we try it, and not guaranteed. We'll email you when it's ready.",
  send: "Send request",
  sending: "Sending…",
  needWants: "Tell us what you'd like us to make.",
  needVideo: "Tick at least one video.",
  videos: (n: number) => `Which videos? ${n ? `(${n} picked)` : ""}`,
  addMore: "+ Add more videos",
  pageTitle: "Artistic edit",
  pageSteps: [
    { icon: "🎬", text: "Tick the videos you want us to work with." },
    { icon: "✍️", text: "Tell us what you'd like: the story, the feel, who it's for." },
    { icon: "🍒", text: "We make your edit." },
    { icon: "📬", text: "We email you, and it's waiting in your Exports." },
  ],
  yourRequests: "Your requests",
  addTitle: "Thought of something else?",
  addPlaceholder: "Add anything: a moment to include, music you like, a deadline…",
  addSend: "Add to my request",
  added: "Added ✓ We'll see it.",
  youAdded: "You added",
  severalVideos: "Want to use several videos?",
  severalVideosLink: "Open the Artistic edit page →",
  addMoreLink: "Add to your request →",
  statusLabel: { new: "Requested", working: "Being made", delivered: "Delivered ✓", declined: "Not this time" } as Record<string, string>,
  sent: "Request sent. We'll email you when your artistic edit is ready.",
  requested: "Artistic edit requested ✓",
  requestedNote: "We'll email you when it's ready.",
  delivered: "Your artistic edit is in Exports",
  deliveredNote: "Open Exports to watch and download it.",
  failed: "Couldn't send it. Try again.",
};

export const STUDIO = {
  title: "Studio",
  sub: "Artistic edit requests. Only staff can see this page.",
  empty: "No requests yet.",
  denied: "This page is for the CherryClipz team.",
  filters: { open: "Open", all: "All" },
  from: "From",
  wants: "Wants",
  about: "About",
  for: "For",
  shape: "Shape",
  feedback: "Will give feedback",
  original: "⬇ Download the original",
  videos: (n: number) => `Videos (${n})`,
  added: (when: string) => `They added · ${when}`,
  note: "Notes (only staff see these)",
  status: { new: "New", working: "Working on it", delivered: "Delivered", declined: "Declined" } as Record<string, string>,
  pickFile: "Choose the finished edit…",
  uploading: (pct: number) => `Uploading… ${pct}%`,
  uploaded: "Uploaded ✓",
  editTitle: "Title they'll see",
  deliver: "Deliver to their Exports + email them",
  delivering: "Delivering…",
  deliveredAs: (t: string) => `Delivered as “${t}”`,
  saved: "Saved",
  error: "Something went wrong. Try again.",
};
